/**
 * Clerk JWT template name used for token fetching
 */
export const CLERK_JWT_TEMPLATE = import.meta.env.VITE_CLERK_JWT_TEMPLATE

/**
 * Session storage key for Clerk token fetch context (used for 500 page retry)
 */
export const CLERK_TOKEN_FETCH_CONTEXT_KEY = 'clerkTokenFetchContext'
